module.exports = __webpack_public_path__ + "static/BG2-013f0615888e78729f9a6e7feb43c9c2.jpg";